// extracted by mini-css-extract-plugin
export default {"custom-toast":"Notifier_custom-toast__Qmd5D","custom-toast-body":"Notifier_custom-toast-body__jS+MP"};